"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkSettings = void 0;
var SdkSettings = /** @class */ (function () {
    /* @ngInject */
    SdkSettings.$inject = ["Wix", "$q"];
    function SdkSettings(Wix, $q) {
        this.Wix = Wix;
        this.$q = $q;
    }
    SdkSettings.prototype.isStandaloneMode = function () {
        return this.Wix.Utils.getViewMode() === 'standalone';
    };
    SdkSettings.prototype.isFullWidth = function () {
        var defer = this.$q.defer();
        if (this.isStandaloneMode()) {
            defer.resolve(false);
        }
        else {
            this.Wix.Settings.isFullWidth(function (res) {
                defer.resolve(res);
            });
        }
        return defer.promise;
    };
    SdkSettings.prototype.getSavedSettings = function (cb) {
        if (this.isStandaloneMode()) {
            var emptySettings = {
                numbers: {},
                booleans: {},
                colors: {},
                fonts: {},
                googleFontsCssUrl: '',
            };
            cb(emptySettings);
        }
        else {
            this.Wix.Styles.getStyleParams(function (res) { return cb(res); });
        }
    };
    SdkSettings.prototype.getStringParam = function (settings, paramName, defaultValue) {
        var fonts = settings.fonts;
        return fonts && fonts.hasOwnProperty(paramName) ? fonts[paramName].value : defaultValue;
    };
    SdkSettings.prototype.getUnitParam = function (settings, paramName, defaultValue) {
        var fonts = settings.fonts;
        return fonts && fonts.hasOwnProperty(paramName) ? +/\d+(\.\d+)?/.exec(fonts[paramName].value)[0] : defaultValue;
    };
    SdkSettings.prototype.getBooleanParam = function (settings, paramName, defaultValue) {
        var booleans = settings.booleans;
        return booleans && booleans.hasOwnProperty(paramName) ? booleans[paramName] : defaultValue;
    };
    SdkSettings.prototype.getNumberParam = function (settings, paramName, defaultValue) {
        var numbers = settings.numbers;
        return numbers && numbers.hasOwnProperty(paramName) ? numbers[paramName] : defaultValue;
    };
    SdkSettings.prototype.getFontParam = function (settings, paramName, defaultValue) {
        var res = defaultValue;
        var fonts = settings.fonts;
        if (fonts && fonts.hasOwnProperty(paramName)) {
            res = fonts[paramName];
            if (typeof res === 'object' && typeof res.preset !== 'string') {
                res.preset = 'Custom';
            } // font style always needs font style.
        }
        return res;
    };
    SdkSettings.prototype.getFontFromPreset = function (presetName) {
        var presets = this.Wix.Styles.getSiteTextPresets();
        var preset = presets[presetName];
        return {
            size: parseInt(preset.size, 10),
            family: preset.fontFamily,
            preset: presetName,
            style: {
                bold: preset.weight === 'bold',
                italic: preset.style === 'italic',
                underline: false,
            },
        };
    };
    // convert {themeName: "color-12", value: '#SSS' to color object
    SdkSettings.prototype.getColorParam = function (settings, paramName, defaultValue, withOpacity, defaultOpacity) {
        var object;
        if (settings.colors &&
            settings.colors.hasOwnProperty(paramName) &&
            Object.keys(settings.colors[paramName]).length > 0) {
            object = this.getColorObject(settings.colors[paramName], withOpacity);
        }
        else {
            object = this.getColorFromTheme(defaultValue, withOpacity, defaultOpacity);
        }
        return object;
    };
    SdkSettings.prototype.getColorFromTheme = function (defaultValue, withOpacity, defaultOpacity) {
        var object = this.getColorObject({ defaultValue: defaultValue }, withOpacity);
        if (withOpacity && typeof defaultOpacity === 'number') {
            object.opacity = defaultOpacity;
            var parts = object.rgba.split(',');
            parts[3] = object.opacity + ")";
            object.rgba = parts.join(',');
        }
        return object;
    };
    SdkSettings.prototype.getColorObject = function (colorEntry, withOpacity) {
        var res = {};
        // get color object if exists
        res.color = false;
        if (this.isHex(colorEntry)) {
            res.color = { value: colorEntry.defaultValue };
        }
        else if (colorEntry.defaultValue) {
            var siteColors = this.Wix.Styles.getSiteColors();
            res.color = siteColors
                ? siteColors.filter(function (color) { return color.reference === colorEntry.defaultValue; })[0]
                : { value: '#FFFFFF' };
        }
        if (withOpacity) {
            res.rgba = colorEntry && colorEntry.value ? colorEntry.value : res.color.value;
            // convert to rgba
            if (res.rgba.indexOf('#') === 0) {
                res.rgba = this.hexToRgba(res.rgba);
            }
            var split = res.rgba.split(',');
            if (split.length > 3) {
                res.opacity = +split[3].replace(')', '');
            }
            else {
                res.opacity = res.rgba === 'transparent' ? 0 : 1;
                res.rgba = "rgba(0,0,0," + res.opacity + ")";
                res.cssColor = res.rgba;
            }
        }
        else {
            res.cssColor = colorEntry && colorEntry.value ? colorEntry.value : res.color.value;
        }
        return res;
    };
    SdkSettings.prototype.isHex = function (colorEntry) {
        return colorEntry.defaultValue && colorEntry.defaultValue.indexOf('#') === 0;
    };
    SdkSettings.prototype.hexToRgba = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
        var opacity = parseInt(result[4], 16);
        opacity = isNaN(opacity) ? 1 : opacity / 255;
        //tslint:disable-next-line
        return ('rgba(' +
            parseInt(result[1], 16) +
            ',' +
            parseInt(result[2], 16) +
            ',' +
            parseInt(result[3], 16) +
            ',' +
            (opacity + ")"));
    };
    return SdkSettings;
}());
exports.SdkSettings = SdkSettings;
